module.exports = __webpack_public_path__ + "static/media/logo.192d6bae.png";